import * as z from 'zod';
import { annualIncomeSchema } from '@/app/register/_annualIncome/schema';
import { birthdaySchema } from '@/app/register/_birthday/schema';
import { genderSchema } from '@/app/register/_gender/schema';
import { phoneNumberSchema } from '@/app/register/_phoneNumber/schema';
import {
  firstNameSchema,
  lastNameSchema
} from '@/app/register/_userName/schema';
import { prefectureSchema } from '@/app/register/_prefecture/schema';
import { degreeSchema } from '@/app/register/_degree/schema';
import { graduationYearSchema } from '@/app/register/_graduationYear/schema';
import { jobExperienceSchema } from '@/app/register/_jobExperience/schema';
import { ownedSkillsSchema } from '@/app/register/_ownedSkills/schema';
import { jobChangeIntentionSchema } from '@/app/register/_jobChangeIntention/schema';
import { numberOfJobChangeSchema } from '@/app/register/_numberOfJobChange/schema';
import { majorSchema } from '@/app/register/_university/schema';
import { desiredEmploymentTypeSchema } from '@/app/register/_desiredEmploymentType/schema';

// NOTE: プロフィール更新時は大学名と会社名を必須にするためschemaを再定義
export const universitySchema = z.object({
  id: z.number().min(0),
  name: z.string().nonempty({ message: '学校名を入力してください。' })
});

export const workplaceSchema = z.object({
  companyOrder: z.number().min(0),
  companyId: z.number().min(0),
  companyName: z.string().nonempty({ message: '会社名を入力してください。' }),
  joinedDate: z.object({
    year: z.string(),
    month: z.string()
  }),
  retiredDate: z.object({
    year: z.string(),
    month: z.string()
  }),
  stayNow: z.boolean(),
  isLatest: z.boolean()
});
export const workplaceListSchema = z.array(workplaceSchema);

export const profileEditSchema = z.object({
  gender: genderSchema,
  birthday: birthdaySchema,
  lastname: lastNameSchema,
  firstname: firstNameSchema,
  phonenumber: phoneNumberSchema,
  prefecture: prefectureSchema,
  degree: degreeSchema,
  graduationyear: graduationYearSchema,
  numberOfJobChange: numberOfJobChangeSchema,
  workplace: workplaceListSchema,
  jobexperience: jobExperienceSchema,
  ownedskills: ownedSkillsSchema,
  jobchangeintention: jobChangeIntentionSchema,
  desiredEmploymentType: desiredEmploymentTypeSchema,
  university: universitySchema,
  major: majorSchema,
  annualincome: annualIncomeSchema
});

export type FormSchema = z.infer<typeof profileEditSchema>;
